module.exports = __webpack_public_path__ + "static/media/crane_blue.843de615.svg";